
export { LucideIcon } from "/codebuild/output/src3223353080/src/packages/shared-components/src/components/LucideIcon.tsx"